import React, { useState, useEffect } from 'react';
import DateDisplay          from './DateDisplay';
import { BsFillPencilFill } from "react-icons/bs";
import { useNavigate }      from 'react-router-dom';

function ChecklistSummaryItem( { clItem, expanded } ) {
    const [item, setItem] = useState();
    const [exp, setExp]   = useState();
    const navigate = useNavigate();
    
    useEffect(() => {
        if (typeof clItem !== 'undefined') {
            setItem(clItem);
        }
        if (typeof expanded !== 'undefined') {
            setExp( expanded );
        }
        
    }, [clItem, expanded]); // Runs when initialData changes

    const handleEdit = (id) => {
        navigate('/update-goal', { state: { id } });     
    }
         
    return(<div> 
              { item ? ( 
                  <>
                  <div className={"cl-item-" + item.is_overdue + "-" + item.item_complete} onClick={() => handleEdit( item.goal_ref )}><BsFillPencilFill /> <DateDisplay dateVal={item.item_due}/> { item.shortcode && (<>{item.shortcode}:</>)}{item.item_description}</div>
                  { exp && (<div className={"cl-long-item-" + item.is_overdue + "-" + item.item_complete } onClick={() => handleEdit( item.goal_ref )}>{item.item_long_description}</div>) }
                  </>
                        ) : 
                        ( <>Loading...</>) }
    </div>);
}

export default ChecklistSummaryItem;
